import { Children, cloneElement, isValidElement, ReactNode, useMemo, useState } from 'react';
import { chakra } from '@chakra-ui/react';
import { useDropdownStyles } from '../Dropdown.context';
import isNodeMatch from '../isNodeMatch';
import { DropdownGroup } from '../DropdownOption';

const NoResultsFound = ({ children }: { children: ReactNode }) => {
  const { item } = useDropdownStyles();
  return (
    <chakra.div __css={item} cursor="default">
      {children}
    </chakra.div>
  );
};
function useSimpleSearch({ children, onSearch }: { children?: ReactNode; onSearch?: () => void }) {
  const [searchValue, setSearchValue] = useState('');
  const searchOnChange = (newValue: string) => {
    setSearchValue(newValue);
    onSearch?.();
  };
  const options = useMemo(() => {
    if (!searchValue) {
      return children;
    }

    const transform = (node: ReactNode): ReactNode => {
      if (isValidElement(node) && node.type === DropdownGroup) {
        const groupChildren = Children.toArray(node.props.children).map(transform).filter(Boolean);
        if (groupChildren.length === 0) {
          return null;
        }
        return cloneElement(node, {
          ...node.props,
          children: groupChildren,
        });
      }
      return isNodeMatch(node, searchValue) ? node : null;
    };

    const results = Children.toArray(children).map(transform).filter(Boolean);

    return results.length ? results : <NoResultsFound>No results found for `{searchValue}`</NoResultsFound>;
  }, [children, searchValue]);

  return { children: options, searchOnChange, searchValue };
}
export { useSimpleSearch, NoResultsFound };
